export const FILTER_VIEW_DASHBOARD = 'dashboard'
export const FILTER_VIEW_SETTINGS = 'settings'
export const PROFILE_MNA_FILTERS = {
  view: FILTER_VIEW_DASHBOARD,
  site: null,
  locus: null,
  siteGroups: [],
  siteTypes: [],
  locusGroups: [],
  regions: [],
}
export const MNA_FILTERS = [
  {
    id: 0,
    name: 'region',
    label: 'region',
    storeName: 'regions',
    value: [],
    data: [],
  },
  {
    id: 1,
    name: 'site-groups',
    label: 'site_groups',
    storeName: 'siteGroups',
    value: [],
    data: [],
  },
  {
    id: 2,
    name: 'site-types',
    label: 'site_types',
    storeName: 'siteTypes',
    value: [],
    data: [],
  },
  {
    id: 4,
    name: 'locus-group',
    label: 'locus_groups',
    storeName: 'locusGroups',
    value: [],
    data: [],
  },
]
